import { ChangeDetectorRef, Component, ElementRef, HostBinding, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { AudioRecordingService } from 'src/app/Service/audio-recording.service';

import { DomSanitizer } from '@angular/platform-browser';

import axios from 'src/app/Service/axios';

import { PersianNumberService } from 'ngx-persian';

declare let $: any;
@Component({

  selector: 'app-violations',

  templateUrl: './violations.component.html',

  styleUrls: ['./violations.component.css']

})

export class ViolationsComponent implements OnInit {

  list_Result: any = [];

  list_Search: any = [];

  lst_Violations: any = []

  bEditMode: boolean = false;

  mdlViolation: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    iDrivingViolations: new FormControl(''),

    strUnitID: new FormControl(''),

    strFullName: new FormControl(''),

    strTitle: new FormControl(''),

    strComment: new FormControl(''),

    iTotalOffense: new FormControl(''),

    strFullDate: new FormControl(''),

    strMobile: new FormControl(''),

    strNationalCode: new FormControl(''),

    strVehicleNo: new FormControl(''),

    pelak1: new FormControl(''),

    pelak2: new FormControl(''),

    pelak3: new FormControl(''),

    pelak4: new FormControl(''),

  })

  constructor(

    private tooltip: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private route: ActivatedRoute,

    private formBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private _persianNumber: PersianNumberService

  ) { }

  ngOnInit(): void {

    this.route.params.subscribe((params) => {

      this.mdlViolation.controls['strUnitID'].setValue(params['id']);

      this.getViolations()

    });

  }

  filter_list(val: any) {

    // this.list_Result = this.list_Search.filter((el: any) => {

    //   return el.strFullName.includes(val.value) ||

    //     el.strMobile.includes(val.value) ||

    //     el.strSDate.includes(val.value) ||

    //     el.strEDate.includes(val.value)

    // });

    // if (val.value.trim() == '') {

    //   this.list_Result = this.list_Search;

    // }

  }

  openModal = async (bEdit: boolean, item?: any) => {

    this.bEditMode = bEdit;

    this.mdlViolation.patchValue({

      iDrivingViolations_Details: '',

      iTotalOffense: '',

      strComment: '',

      strTitle: '',

      strFullDate: '',

      strNationalCode: '',

    })

    if (this.bEditMode) {

      Object.keys(item).forEach((key: any) => {

        this.mdlViolation.get(key)?.setValue(item[key].toLocaleString())

      })

      this.otherService.Showspinner();

      const resp = await axios.post(`DrivingViolations_Details_List`, this.otherService.stringNumberToNumber(this.mdlViolation.value));
  
      this.otherService.nonespinner();

      let res = JSON.parse(resp.data);

      if (res.iResult == 0) return this.tooltip.showError(res.strError);

      this.lst_Violations = res;
      
    }

    this.formatted_pelak(this._persianNumber.toPersian(this.mdlViolation.get('strVehicleNo')?.value))

    $("#violation-modal").modal("show");


  }

  getViolations = async () => {

    this.otherService.Showspinner();

    const resp = await axios.post(`DrivingViolations_List`, this.otherService.stringNumberToNumber(this.mdlViolation.value));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this.tooltip.showError(res.strError)

    if (res.length > 0) {

      this.mdlViolation.controls['strFullName'].setValue(res[0].strFullName);

      this.mdlViolation.controls['strMobile'].setValue(res[0].strMobile);

      this.mdlViolation.controls['strVehicleNo'].setValue(res[0].strVehicleNo);

      this.list_Result = res;

      this.list_Search = res;

      this.formatted_pelak(this._persianNumber.toPersian(this.mdlViolation.get('strVehicleNo')?.value))

    }

  }

  formatted_pelak(strVehicle: any) {

    this.mdlViolation.get('pelak1')?.setValue(strVehicle.split(' ')[0])

    this.mdlViolation.get('pelak2')?.setValue(strVehicle.split(' ')[1])

    this.mdlViolation.get('pelak3')?.setValue(strVehicle.split(' ')[2])

    this.mdlViolation.get('pelak4')?.setValue(strVehicle.split(' ')[4])

  }

}
